import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import Error from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import RulesCard from "./RulesCard";
import TopCard from "./TopCard";

const backend = await new Backend().init();

export default function Rules() {
  const [play] = useSound(Error);
  const windowSize = useSize();
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadRules();
  }, []);

  const loadRules = async () => {
    setLoading(true);
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    try {
      const r = await backend.rules(data);
      setLoading(false);
      if (r.error === "False") {
        setRules(r.rules || []);
      } else {
        play();
        toast.error(r.message);
      }
    } catch (e) {
      setLoading(false);
      play();
      toast.error("Failed to load rules. Please try again.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TopCard
        title="Trading Rules"
        subtitle="Please read carefully before trading."
      />

      <div>
        {loading ? (
          <div className="flex-1 flex justify-center items-center">
            <Loading height={windowSize[1] - 130} />
          </div>
        ) : rules.length > 0 ? (
          <div
            style={{
              width: windowSize[0],
              height: windowSize[1] - 130,
              overflowY: "scroll",
              scrollBehavior: "smooth",
              paddingBottom: 200,
            }}
            className="grid p-4 grid-cols-1 md:grid-cols-2 gap-4 mt-3"
          >
            {rules.map((rule, index) => (
              <RulesCard key={index} rule={rule} index={index + 1} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 130}
            title={"No Rules Found"}
            subtext={"There are currently no active trading rules."}
            small
          />
        )}
      </div>
    </div>
  );
}
